var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ul',[_vm._v("Denne siden er under oppbygging, da vår leverandør av nettbutikken brått frafallt.. "),_c('br'),_vm._v(" Dette påvirker naturligvis ikke tjenesten. Logg inn i dashboordet i menyen."),_c('br'),_c('br'),_vm._v(" I mellomtiden, for spørsmål eller bestillinger, ta kontakt, så hjelper vi deg! :)"),_c('br')])
}]

export { render, staticRenderFns }